import { mdiWindowClose, mdiWindowMaximize, mdiWindowMinimize, mdiWindowRestore, } from "@mdi/js";
import React from "react";
import { close, minimize, toggleMaximize, useIsMaximized, } from "../../../hooks";
import { Icon } from "../../../ui/components/icon/Icon";
import { joinClasses } from "../../../ui/utils/joinClasses";
const WindowControlButton = ({ className, iconPath, ...props }) => (React.createElement("button", { className: joinClasses([
        "flex size-11 items-center justify-center text-neutral-subdued -outline-offset-2 transition-colors hover:text-neutral-strong",
        className,
    ]), ...props },
    React.createElement(Icon, { path: iconPath, size: "sm" })));
export const WindowControls = () => {
    const isMaximized = useIsMaximized();
    return (React.createElement("div", { className: "flex" },
        React.createElement(WindowControlButton, { className: "hover:bg-surface-mid", iconPath: mdiWindowMinimize, title: "Minimize", onClick: minimize }),
        React.createElement(WindowControlButton, { className: "hover:bg-surface-mid", iconPath: isMaximized ? mdiWindowRestore : mdiWindowMaximize, title: isMaximized ? "Restore" : "Maximize", onClick: toggleMaximize }),
        React.createElement(WindowControlButton, { className: "hover:bg-danger-subdued", iconPath: mdiWindowClose, title: "Close", onClick: close })));
};
